export const SETUP_KEY_QUERY_PARAM = 'payment_setup';

const STRIPE_REDIRECT_PARAMS = ['setup_intent', 'setup_intent_client_secret', 'redirect_status'];
const REDIRECT_PARAMS = [...STRIPE_REDIRECT_PARAMS, SETUP_KEY_QUERY_PARAM];

/** Current page plus the setup key, so the setup can finish after a processor redirect. */
export const buildSetupReturnUrl = (setupKey: string, href = window.location.href) => {
  const url = new URL(href);
  REDIRECT_PARAMS.forEach((param) => url.searchParams.delete(param));
  url.searchParams.set(SETUP_KEY_QUERY_PARAM, setupKey);
  return url.toString();
};

/** The Stripe client secret from a redirect back to this page, if it belongs to `setupKey`. */
export const readStripeSetupRedirect = (setupKey: string, search = window.location.search) => {
  const params = new URLSearchParams(search);
  const clientSecret = params.get('setup_intent_client_secret');
  if (!clientSecret || params.get(SETUP_KEY_QUERY_PARAM) !== setupKey) return undefined;
  return { clientSecret };
};

export const clearSetupRedirectParams = () => {
  const url = new URL(window.location.href);
  REDIRECT_PARAMS.forEach((param) => url.searchParams.delete(param));
  window.history.replaceState(window.history.state, '', url.toString());
};

const nameStorageKey = (setupKey: string) => `${SETUP_KEY_QUERY_PARAM}:${setupKey}:name`;

/** Keeps the cardholder name for the tab session; Stripe's redirect return doesn't carry it. */
export const saveSetupCardholderName = (setupKey: string, name: string) => {
  try {
    window.sessionStorage.setItem(nameStorageKey(setupKey), name);
  } catch {
    // Storage unavailable; the name can't survive a redirect.
  }
};

export const readSetupCardholderName = (setupKey: string) => {
  try {
    return window.sessionStorage.getItem(nameStorageKey(setupKey)) ?? '';
  } catch {
    return '';
  }
};

export const clearSetupCardholderName = (setupKey: string) => {
  try {
    window.sessionStorage.removeItem(nameStorageKey(setupKey));
  } catch {
    // Nothing to clear.
  }
};
